var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSprinkleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3468509",
    d: "M9.37257 16.6036C8.34495 13.4927 5.92681 10.9955 2.84464 9.89596C5.94756 8.96578 8.41883 6.55237 9.41682 3.46201C10.4463 6.50615 12.9149 8.89269 15.9878 9.85271C12.8321 10.9119 10.3654 13.4352 9.37257 16.6036Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3468510",
    d: "M14 3.45035C15.3242 3.45035 16.4132 2.40707 16.4701 1.08412L16.4737 1C16.5029 2.36172 17.638 3.45035 19 3.45035L18.912 3.45603C17.5624 3.54309 16.5035 4.64788 16.4737 6C16.4142 4.64969 15.3486 3.54122 14 3.45035Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprinkleIcon);
export default __webpack_public_path__ + "static/media/sprinkleIcon.6519148442f6e41f1d7be6a4cf3a2ce4.svg";
export { ForwardRef as ReactComponent };